import { groupBy, sortBy } from "lodash";
import React from "react";
import { SimpleCard } from "src/app/components";
import Pacman from "src/app/components/layout/Pacman";
import useRDByThematicIds from "src/app/hooks/useRDByThematicIds/useRDByThematicIds";

const RDListByThematicIdContainer: React.FC<{ moneySiteId: number; thematicId: Array<number> }> = ({
    thematicId,
    moneySiteId,
}) => {
    const { rdList, loading } = useRDByThematicIds(moneySiteId, thematicId);
    if (loading) return <Pacman />;
    if (rdList.length === 0) return <span className="form-label">no Rds</span>;
    const rdListGrouped = groupBy(
        sortBy(rdList, (el) => el.domain),
        "thematic"
    );

    return (
        <div
            style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: "16px",
                maxHeight: "60vh",
                overflowY: "auto",
            }}
        >
            {Object.keys(rdListGrouped).map((thematic, thematicIndex) => (
                <SimpleCard
                    header={`${thematic} (${rdListGrouped[thematic as string].length})`}
                    cardProps={{
                        style: {
                            background: "var(--kt-primary)",
                            color: "white",
                            fontWeight: "600",
                            lineHeight: "1.5rem",
                        },
                    }}
                    headerProps={{
                        style: {
                            fontSize: "18px",
                            minHeight: "32px",
                            display: "flex",
                            alignContent: "center",
                        },
                    }}
                    key={thematicIndex}
                >
                    <div style={{ maxHeight: "470px", overflowY: "auto" }}>
                        {rdListGrouped[thematic as string].map((el, index) => (
                            <span key={index}>
                                {el.domain}
                                <br />
                            </span>
                        ))}
                    </div>
                </SimpleCard>
            ))}
        </div>
    );
};

export default RDListByThematicIdContainer;
